import { MouseEventHandler } from 'react';

import clsx from 'clsx';

import BoldIcon from '../../icons/BoldIcon';
import ItalicIcon from '../../icons/ItalicIcon';
import UnderlineIcon from '../../icons/UnderlineIcon';
import ToolbarButton, { Props as ToolbarButtonProps } from '../../ToolbarButton';
import { TextFormat } from '../../types';
import { textFormattingButtonsClasses } from './styles';
import useTextFormattingButtonsVM, { Props as VMProps } from './vm';

export type Props = VMProps &
  ToolbarButtonProps & {
    classes?: Partial<typeof textFormattingButtonsClasses>;
  };

const TextFormattingButtons = ({ classes, editorRef, ...props }: Props) => {
  const { isBoldActive, isItalicActive, isUnderlineActive, onToggleMark } = useTextFormattingButtonsVM({
    editorRef,
  });

  const handleMouseDown =
    (mark: keyof TextFormat): MouseEventHandler<HTMLButtonElement> =>
    (event) => {
      event.preventDefault();
      onToggleMark(mark);
    };

  return (
    <>
      <ToolbarButton
        {...props}
        isActive={isBoldActive}
        onMouseDown={handleMouseDown('bold')}
        className={clsx(
          textFormattingButtonsClasses.toolbarButton,
          classes?.toolbarButton,
          textFormattingButtonsClasses.bold,
          classes?.bold
        )}
      >
        <BoldIcon
          size={16}
          className={clsx(
            textFormattingButtonsClasses.toolbarIcon,
            classes?.toolbarIcon,
            textFormattingButtonsClasses.boldIcon,
            classes?.boldIcon
          )}
        />
      </ToolbarButton>
      <ToolbarButton
        {...props}
        isActive={isItalicActive}
        onMouseDown={handleMouseDown('italic')}
        className={clsx(
          textFormattingButtonsClasses.toolbarButton,
          classes?.toolbarButton,
          textFormattingButtonsClasses.italic,
          classes?.italic
        )}
      >
        <ItalicIcon
          size={16}
          className={clsx(
            textFormattingButtonsClasses.toolbarIcon,
            classes?.toolbarIcon,
            textFormattingButtonsClasses.italicIcon,
            classes?.italicIcon
          )}
        />
      </ToolbarButton>
      <ToolbarButton
        {...props}
        isActive={isUnderlineActive}
        onMouseDown={handleMouseDown('underline')}
        className={clsx(
          textFormattingButtonsClasses.toolbarButton,
          classes?.toolbarButton,
          textFormattingButtonsClasses.underline,
          classes?.underline
        )}
      >
        <UnderlineIcon
          size={16}
          className={clsx(
            textFormattingButtonsClasses.toolbarIcon,
            classes?.toolbarIcon,
            textFormattingButtonsClasses.underlineIcon,
            classes?.underlineIcon
          )}
        />
      </ToolbarButton>
    </>
  );
};

export default TextFormattingButtons;
